import createHTMLMediaHook from './createHTMLMediaHook';

export const useAudio = createHTMLMediaHook<HTMLAudioElement>('audio');
